
<div class="container-fluid alone full-height">
    <div class="row align-items-center consumptionCard">
        <div class="col-md-12">
            <h3 class="section-title mb-2">
                {{ 'CONSUMPTION.CONSUMPTION.HAND_DISINFECTANT' | translate }}
            </h3>
        </div>
        <div class="col-md-12" *ngFor="let item of consumptionData">
            <ul class="advise-container d-flex justify-content-end">
                <li> {{item.year}} </li>
                <li> {{item.wardName | translate | labelSanitizer}} </li>
                <li> {{item.departmentName | translate | labelSanitizer}} </li>
            </ul>
        </div>
        <!-- <div class="col-md-12 d-flex justify-content-end">
        <div class="action-btn-box align-items-end">
        <button class="btn btn-primary btn-secondary" [disabled]="!isMilliliter" [ngClass]="viewFlag=='milliliter'?'action-btn-active':''" (click)="changeView('milliliter')">Milliliter
          <span class="badge badge-light"></span>
        </button>
        <button class="btn btn-primary btn-secondary" [disabled]="!isLiter" [ngClass]="viewFlag=='liter'?'action-btn-active':''" (click)="changeView('liter')">Liter
          <span class="badge badge-light"></span>
        </button>
      </div>
    </div> -->
    </div>
</div>
<form [formGroup]="consumptionQuarterPeriodForm">
    <table>
        <thead>
            <tr>
                <th scope="col">{{'CONFIGURE.PERIOD_1' | translate}}
                    <span class="italicFont"> {{'CONSUMPTION.IN_QUARTERS' | translate}}</span>
                </th>
                <th class="border-left" scope="col"> {{ amountMeasure() }}
                    <span class="italicFont"> ({{unitMeasure()}})</span>
                </th>
                <th class="border-left" scope="col">{{'CONSUMPTION.PATIENT_DAYS' | translate}}
                    <span class="italicFont"> {{'CONSUMPTION.IN_DAYS' | translate}}</span>
                </th>
                <th *ngIf="haiEnabled" class="border-left" scope="col">{{'CONSUMPTION.HAI' | translate}}
                    <span class="italicFont"> {{'CONSUMPTION.OCCURRENCES' | translate}}</span>
                </th>
                <th hidden></th>
            </tr>
        </thead>
        <tbody formArrayName="items" *ngFor="let item of getControls(consumptionQuarterPeriodForm, 'items'); let i = index;">
            <tr [formGroupName]="i">
                <td>{{ 'CONFIGURE.QUARTER' | translate }} {{i+1}}</td>
                <td>
                  <input *ngIf="isLiters()" type="text" onlynumber=true class="form-control" min="0" [mask]="'separator.2'" [thousandSeparator]="''" [dropSpecialCharacters]="false" [ngClass]="viewConsumption ? '' : 'readOnlyText'" value="{{item.consumptionValue}}" formControlName="consumptionValue">
                  <input *ngIf="isMilliliters()" type="text" onlynumber=true class="form-control" min="0" mask="00000000" [ngClass]="viewConsumption ? '' : 'readOnlyText'" value="{{item.consumptionValue}}" formControlName="consumptionValue">
                </td>
                <td>
                  <input type="text" onlynumber=true class="form-control" min="0" mask="00000000" [ngClass]="viewConsumption ? '' : 'readOnlyText'" value="{{item.patientDays}}" [ngClass]="viewConsumption ? '' : 'readOnlyText'" formControlName="patientDays">
                </td>
                <td *ngIf="haiEnabled">
                  <input type="text" onlynumber=true class="form-control" min="0" mask="00000000" [ngClass]="viewConsumption ? '' : 'readOnlyText'" formControlName="haiOccurrences">
                </td>
                <input type="number" class="form-control" [ngClass]="viewConsumption ? '' : 'readOnlyText'" value="{{item.consumptionPeriodID}}" formControlName="consumptionPeriodID" hidden>
            </tr>
        </tbody>
    </table>
</form>

<div class="col-auto d-flex justify-content-end mt-3">
    <button class="btn btn-bd" *ngIf="!viewConsumption" (click)="EditConsumption()">{{ 'CONFIGURE.EDIT' | translate }}</button>
    <button *ngIf="viewConsumption"  (click)="cancelConsupmtionPeriod()" class="btn btn-cancel-bordered-bd mr-4">{{ translationKeys.Authorization.Cancel | translate }}</button>
    <button *ngIf="viewConsumption" class="btn btn-bd" (click)="updateConsumptionPeriod()">{{ translationKeys.Observation.Update | translate }}</button>
</div>
<br>
